import { render } from "./AddAppointment.vue?vue&type=template&id=0e89e1c4&scoped=true"
import script from "./AddAppointment.vue?vue&type=script&lang=js"
export * from "./AddAppointment.vue?vue&type=script&lang=js"

import "./AddAppointment.vue?vue&type=style&index=0&id=0e89e1c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e89e1c4"]])

export default __exports__